<div
    class="flex justify-center mb-2 mr-2 py-1 px-4 bg-{{workspaceColor}} text-white text-sm rounded-lg cursor-pointer hover:shadow-dark"
>
    <span>{{workspaceName}}</span>
</div>
